import React from "react";
import DashboardSkeleton from "./Dashboard";

const Skeleton = ({ type = "dashboard" }) => {
  const typeMapping = {
    dashboard: DashboardSkeleton,
  };

  const SkeletonType = typeMapping[type] || DashboardSkeleton;

  return <SkeletonType />;
};

export default Skeleton;
